import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider } from './context/themeContext';
import { AuthProvider } from './context/authContext';
import AppRoutes from './routes/appRoutes';
import { setupApi } from '@dc-trans/data-layer';
import { webStorage } from './utils/auth';
import { ConfigProvider } from 'antd';
import NotificationProvider from './context/notificationContext';
import ApiErrorNotificationProvider from './context/apiErrorNotificationProvider';
import { UrlParamsProvider } from './context/urlParamsContext';
import { PreviewWrapper } from './components/ui/modal';
import { QueryClientProvider } from '@tanstack/react-query';
import queryClient from './libs/queryClient';

// setup api with web storage
setupApi(webStorage, {
  baseURL: import.meta.env.VITE_API_BASE_URL,
  xClient: import.meta.env.VITE_VENDOR_CLIENT_ID,
});

function App() {
  return (
    <Router basename={import.meta.env.BASE_URL}>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <NotificationProvider>
            <ApiErrorNotificationProvider>
              <ConfigProvider
                theme={{
                  token: {
                    colorPrimary: '#eb008b',
                  },
                }}
              >
                <ThemeProvider>
                  <UrlParamsProvider initialValues={{ page: 1, limit: 20 }}>
                    <PreviewWrapper>
                      <AppRoutes />
                    </PreviewWrapper>
                  </UrlParamsProvider>
                </ThemeProvider>
              </ConfigProvider>
            </ApiErrorNotificationProvider>
          </NotificationProvider>
        </AuthProvider>
      </QueryClientProvider>
    </Router>
  );
}

export default App;
